import { Participation } from '@/types/api/participation';
import { ParticipationListItem } from '../components/participation-list';

export const participationToListItem = (p: Participation): ParticipationListItem => ({
  user: p.user!.name,
  userId: p.userId,
  itemCount: p.unitCount,
  collected: p.collected,
});
